import React from 'react';


// Think better: we may use global objects as well to hold global states.
export const AppContext = React.createContext();
